<form #editContactForm="ngForm">
	<div class="contact-row">
		<div class="contact-label">Name:</div>
		<div class="contact-span">
			<input class="text-input" type="text" [(ngModel)]="contact.name" name="contactName">
		</div>
	</div>
	<div class="contact-row">
		<div class="contact-label">Phone:</div>
		<div class="contact-span">
			<p-inputMask mask="(999) 999-9999" class="text-input" (ngModelChange)="telephoneChanged()"
				[autoClear]="false" [(ngModel)]="contact.phone1" [ngModelOptions]="{standalone: true}">
			</p-inputMask>
		</div>
	</div>
	<div class="contact-row">
		<div class="contact-label">E-Mail:</div>
		<div class="contact-span">
			<input class="text-input" type="email" [(ngModel)]="contact.email" name="contactEmail">
		</div>
	</div>
	<div class="contact-row">
		<div class="contact-label">Default:</div>
		<div class="contact-span switch-block">
            <p-inputSwitch [(ngModel)]="contact.isDefault" name="contactIsDefault"></p-inputSwitch>
		</div>
	</div>
</form>
